import { useMemo } from 'react';
import { ValidationMessagesMap } from '../../../common/utils/ValidationMessagesMap';
import { useCheckBrokenReferencesQuery } from '../query/useCheckBrokenReferencesQuery';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UseBrokenReferences.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'use-broken-references',
);
addTranslations(translations);

export const useBrokenReferences = (algorithmIds: number[]) => {
  const { data, refetch, isFetching } = useCheckBrokenReferencesQuery(
    { algorithmIds: algorithmIds.length > 0 ? Array.from(algorithmIds) : [] },
    { enabled: false },
  );
  const { t } = useTranslation();

  return {
    brokenReferencesMap: useMemo(
      () =>
        !isFetching && data
          ? ValidationMessagesMap.fromApiErrors(data.errors, (code, meta) =>
              t(`alert.error.code.${code}`, meta?.args && { ...meta.args }),
            )
          : undefined,
      [isFetching, data, t],
    ),
    refetch,
    isFetching,
  };
};
